export interface ChartDataInterface {
  item: string;
  values: number[];
  labels?: string[];
  type?: ChartDataType;
}

export enum ChartTheme {
  WHITE = 'white',
  DARK = 'dark',
}

export type ChartLegendPosition = 'top' | 'bottom';

export enum ChartDataType {
  NUMBER = 'number',
  PERCENTAGE = 'percentage',
  CURRENCY = 'currency',
}

